"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Transition = require("react-transition-group/Transition");

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function DefaultTransition(_ref) {
  var children = _ref.children,
      position = _ref.position,
      props = _objectWithoutProperties(_ref, ["children", "position"]);

  return _react2.default.createElement(
    _Transition2.default,
    _extends({}, props, {
      timeout: 750,
      onEnter: function onEnter(node) {
        node.classList.add("toast-enter--" + position);
        node.classList.add("toastify-animated");
      },
      onExit: function onExit(node) {
        node.classList.remove("toast-enter--" + position);
        node.classList.remove("toastify-animated");
        node.classList.add("toast-exit--" + position);
        node.classList.add("toastify-animated");
      }
    }),
    children
  );
}

exports.default = DefaultTransition;


//////////////////
// WEBPACK FOOTER
// ./~/react-toastify/lib/DefaultTransition.js
// module id = 2288
// module chunks = 0